export const hideEmail = (email: string) => {
  if (email == null) {
    return '';
  }
  const [username, domain] = email.split('@');
  const hiddenUsername = `${username[0]}${'*'.repeat(username.length - 1)}`;
  return `${hiddenUsername}@${domain}`;
};
